import { v1 as uuidv1 } from 'uuid';

export const TYPE_SET_POSLIST = `PointsOfSale: SET_POSLIST→${uuidv1()}`;
export const TYPE_SELECTPOS = `PointsOfSale: SELECT_POS→${uuidv1()}`;
export const TYPE_SET_LOADING = `PointsOfSale: SET_LOADING→${uuidv1()}`;
export const UPDATE_CURRENT_POS = `PointsOfSale: UPDATE_CURRENT_POS→${uuidv1()}`;
